import type { ReactNode } from 'react';
import logo from '../../../assets/logos/aye-logo.png';
import PayNetFooter from '../../../shared/PayNetFooter';

/**
 * Full-screen result page: the logo at the top, the footer at the bottom, and the content
 * centred vertically in the space between them.
 */
export function ResultLayout({ children }: Readonly<{ children: ReactNode }>) {
  return (
    <div className="flex min-h-screen flex-col items-center bg-white">
      <img src={logo} alt="Aye Logo" className="mt-9 h-8 w-16 flex-shrink-0" />

      <main
        data-testid="result-content"
        className="flex w-full max-w-md flex-1 flex-col items-center justify-center px-6 py-8"
      >
        {children}
      </main>

      <div className="my-4 flex justify-center">
        <PayNetFooter />
      </div>
    </div>
  );
}

/** The app's success illustration, the same one its settings confirmations show. */
export function SuccessIllustration({ alt }: Readonly<{ alt: string }>) {
  return (
    <img
      src="/assets/images/update-phone-success.png"
      alt={alt}
      className="mx-auto w-40"
    />
  );
}
